module.exports = __webpack_public_path__ + "static/img/salepage-stk-promotion_09.9434ec1.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/salepage/banner/promotion/salepage-stk-promotion_09.webp
// module id = L89T
// module chunks = 134